import React from "react";
import { PulseLoader } from "./pulse_loader";
import { stylex } from "./stylex";

export function PageLoader() {
  return (
    <div style={styles("root")}>
      <PulseLoader />
    </div>
  );
}

const styles = stylex.create({
  root: {
    display: "flex",
    justifyContent: "center",
    paddingTop: 80,
    boxSizing: "border-box",
  },
});
